const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user likes component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('mainNav', [
  'Application',
  'Authorization',
  'AccessHelper',
  'UrlLookup',
  '$interval',
  '$timeout',
  function (Application, Authorization, AccessHelper, UrlLookup, $interval, $timeout) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        visibility: '=?',
        closeusercontextmenu: '=?',
        usermenuvisibility: '=?',
      },
      template: require('../../templates/directives/main-nav.html'),
      controller: [
        '$scope',
        function ($scope) {
          var self = this;
          self.urlLookup = UrlLookup;
          self.isActive = true;
          self.activeSubnav = '';
          self.previousSubnav = '';

          self.searchResults = [];
          self.searchValue = '';
          self.features = Application.features.flags();

          self.routeIsSubitem = false;
          self.subitemParent = '';
          self.currentLocation = '';

          // actions
          self.hideNav = () => {
            $scope.visibility = false;
          };
          self.clearSearchResults = () => {
            self.searchResults = [];
          };
          self.resetSublists = () => {
            $timeout(() => {
              let allLists = document.querySelectorAll('.js-sublist');
              for (let i = 0; i < allLists.length; i++) {
                allLists[i].style.height = '0px';
              }
            }, 250);
          };

          self.mouseOutHandler = () => {
            self.clearSearchResults();
            document.querySelector('.js_navsearch').blur();
            self.previousSubnav = self.activeSubnav;
            self.activeSubnav = '';
            self.searchValue = '';
            self.resetSublists();
          };
          self.mouseEnterHandler = () => {
            if (self.previousSubnav.length) {
              self.activeSubnav = self.previousSubnav;
              let elm = document.querySelector(`[data-listid="${self.previousSubnav}"`);
              elm.style.height = elm.querySelector('.mainNav__list__sublist').clientHeight + 'px';
            }
          };

          self.clickHandler = () => {
            self.hideNav();
            $scope.usermenuvisibility = false;
            self.previousSubnav = '';
            self.activeSubnav = '';
            self.resetSublists();
          };

          self.setSubnav = (input, event) => {
            event.preventDefault();
            if (self.activeSubnav === input) {
              self.activeSubnav = '';
              document.querySelector(`[data-listid="${input}"`).style.height = 0 + 'px';
              return;
            }
            self.activeSubnav = input;

            let allItems = document.querySelectorAll('.js-sublist');
            for (let i = 0; i < allItems.length; i++) {
              allItems[i].style.height = '0px';
            }
            let elm = document.querySelector(`[data-listid="${input}"`);
            elm.style.height =
              elm.querySelector('.mainNav__list__sublist').clientHeight + 'px';
          };

          self.isCurrentLocation = (location) => {
            if (location) {
              return window.location.hash.substring(2).startsWith(location);
            } else {
              return false;
            }
          };

          self.inputChange = () => {
            self.clearSearchResults();
            if (!self.searchValue) {
              self.resetSublists();
            }

            for (let i = 0; i < self.navDef.length; i++) {
              if (
                self.navDef[i].id.toLowerCase().startsWith(self.searchValue.toLowerCase()) &&
                self.navDef[i].allow
              ) {
                self.searchResults.push(self.navDef[i]);
              }
            }
            let subnavArr = Object.keys(self.subnavs);
            for (let i = 0; i < subnavArr.length; i++) {
              let sn = self.subnavs[subnavArr[i]];
              let subnavId = subnavArr[i];
              for (let e = 0; e < sn.length; e++) {
                let getParent = (id) => {
                  return self.navDef.find((item) => item.id === id);
                };
                if (
                  sn[e].text.toLowerCase().startsWith(self.searchValue.toLowerCase()) &&
                  getParent(subnavId).allow
                ) {
                  self.searchResults.push({ parent: getParent(subnavId), ...sn[e] });
                }
              }
            }
          };

          self.shutterAll = () => {
            let allSubnavs = document.querySelectorAll('.js-sublist');
            for (let i = 0; i < allSubnavs.length; i++) {
              let id = allSubnavs[i].dataset.listid;
              if (id !== self.activeSubnav) {
                allSubnavs[i].style.height = '0px';
              }
            }
          };

          // Auth stuff
          self.isAdmin = function () {
            return Authorization.isAdmin();
          };
          self.isCreator = function () {
            return Authorization.isCreator();
          };
          self.isCollaborator = function () {
            return Authorization.isCollaborator();
          };
          self.isManager = function () {
            if (!Authorization.hasValidAuthToken()) {
              return false;
            }
            if (!Authorization.getAuthToken().user) {
              return false;
            }
            return Authorization.getAuthToken().user.is_manager;
          };
          self.isGrader = function () {
            if (!Authorization.hasValidAuthToken()) {
              return false;
            }
            if (!Authorization.getAuthToken().user) {
              return false;
            }
            return Authorization.getAuthToken().user.is_grader;
          };

          self.allowance = {
            overview: AccessHelper.isAllowed(['admin', 'overview'], null, ['admin']),
            users: AccessHelper.allowGeneralActivity('users', ['admin']),
            content: AccessHelper.allowGeneralActivity('content', [
              'admin',
              'creator',
              'collaborator',
            ]),
            workshops:
              self.features.workshops &&
              AccessHelper.allowGeneralActivity('workshops', ['admin', 'creator', 'collaborator']),
            assessments:
              self.features.assessments &&
              AccessHelper.allowGeneralActivity('assessments', [
                'admin',
                'creator',
                'collaborator',
              ]),
            assignments: AccessHelper.allowGeneralActivity('assignments', ['admin', 'creator']),
            assignmentsV2: self.features.enable_assignment_view_v2,
            workflows: AccessHelper.isAllowed(['admin', 'workflows'], null, ['admin', 'creator']),
            reports:
              self.features.reports &&
              AccessHelper.isAllowed(['admin', 'reports'], null, ['admin']),
            badges:
              self.features.badges && AccessHelper.isAllowed(['admin', 'badges'], null, ['admin']),
            journeys:
              self.features.journeys &&
              AccessHelper.allowGeneralActivity('journeys', ['admin', 'creator']),
            surveys:
              self.features.surveys &&
              AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
            settings: AccessHelper.isAllowed(['admin', 'settings'], null, ['admin']),
            dedicated_workshops:
              self.features.dedicated_workshops &&
              AccessHelper.allowGeneralActivity('workshops', ['admin', 'creator', 'collaborator']),
            registrationForms:
              self.features.enable_registration_forms &&
              AccessHelper.isAllowed(['admin', 'registration_forms'], null, ['admin']),
            theme: AccessHelper.isAllowed(['explore', 'update_theme'], null, ['admin']),
            ecommerce:
              self.features.enable_ecommerce &&
              AccessHelper.isAllowed(['admin', 'ecommerce'], null, ['admin']),
            continuInsights:
              self.features.enable_continu_insights &&
              AccessHelper.isAllowed(['admin', 'reports'], null, ['admin']),
            connectCategories: AccessHelper.isAllowed(['admin', 'connect', 'categories'], null, [
              'admin',
            ]),
            connectLocations: AccessHelper.isAllowed(['admin', 'connect', 'locations'], null, [
              'admin',
            ]),
            connectDepartments: AccessHelper.isAllowed(['admin', 'connect', 'departments'], null, [
              'admin',
            ]),
            connectTeams: AccessHelper.isAllowed(['admin', 'connect', 'teams'], null, ['admin']),
            connectLevels: AccessHelper.isAllowed(['admin', 'connect', 'levels'], null, ['admin']),
            connectGrades: AccessHelper.isAllowed(['admin', 'connect', 'grades'], null, ['admin']),
            connectGroups: AccessHelper.isAllowed(['admin', 'connect', 'groups'], null, ['admin']),
            connectSkills: AccessHelper.isAllowed(['admin', 'connect', 'skills'], null, ['admin']),
          };
          self.allowance.applicationTokens =
            (self.features.linkedin_learning || self.features.open_api) && self.allowance.settings;
          self.allowance.profiles = self.features.profiles && self.allowance.settings;
          self.allowance.webhooks = self.features.enable_webhooks && self.allowance.settings;
          self.allowance.partners =
            self.features.enable_partners && AccessHelper.isAllowed(['admin'], null, ['admin']);
          self.allowance.metadata =
            self.features.enable_metadata &&
            AccessHelper.isAllowed(['admin', 'settings'], null, ['admin']);

          self.topLevelClick = function (item, e, hideNav) {
            if (!item.url) {
              e.preventDefault();
              return;
            }

            if (hideNav) {
              self.hideNav();
            }
          };

          self.navDef = [
            {
              id: 'explore',
              label: 'global.vertNavbar.explore',
              url: self.urlLookup.explore(),
              hasSubnav: false,
              icon: 'navExplore',
              allow: true,
            },
            {
              id: 'dashboard',
              label: 'global.vertNavbar.dashboard',
              url: self.urlLookup.dashboard(),
              hasSubnav: false,
              icon: 'navDashboard',
              allow: true,
            },
            {
              id: 'manager',
              label: 'global.vertNavbar.managers',
              url: '#/manager',
              hasSubnav: false,
              icon: 'navManager',
              allow: self.isManager() || self.isGrader(),
            },
            {
              id: 'create',
              label: 'global.actions.create',
              url: '',
              hasSubnav: true,
              icon: 'navCreate',
              allow:
                self.allowance.content ||
                self.allowance.workshops ||
                self.allowance.assessments ||
                self.allowance.badges ||
                self.allowance.surveys,
            },
            {
              id: 'share',
              label: 'global.interactions.share',
              url: '',
              hasSubnav: true,
              icon: 'navShare',
              allow:
                self.allowance.assignments || self.allowance.journeys || self.allowance.workflows,
            },
            {
              id: 'connect',
              label: 'global.leftnav.connect',
              url: '',
              hasSubnav: true,
              icon: 'navConnect',
              allow:
                self.allowance.connectCategories ||
                self.allowance.connectLocations ||
                self.allowance.connectDepartments ||
                self.allowance.connectTeams ||
                self.allowance.connectLevels ||
                self.allowance.connectGrades ||
                self.allowance.connectGroups ||
                self.allowance.connectSkills,
            },
            {
              id: 'admin',
              label: 'global.vertNavbar.overview',
              url: '',
              hasSubnav: true,
              icon: 'navAdmin',
              allow:
                self.allowance.overview ||
                self.allowance.applicationTokens ||
                self.allowance.settings ||
                self.allowance.profiles ||
                self.allowance.users,
            },
            {
              id: 'extend',
              label: 'global.leftnav.extend',
              url: '#/overview/settings',
              hasSubnav: false,
              icon: 'navExtended',
              allow: false,
            },
            {
              id: 'workshop',
              label: 'global.contentTypes.workshops',
              url: '../workshops',
              hasSubnav: false,
              icon: 'navWorkshop',
              allow: self.allowance.workshops && self.allowance.dedicated_workshops,
            },
          ];

          self.subnavs = {
            create: [
              {
                text: 'Content',
                key: 'edit.general.sidebar_content',
                url: '/admin/content',
                allowed: self.allowance.content,
              },
              {
                text: 'Assessments',
                key: 'global.contentTypes.assessments',
                url: self.urlLookup.assessmentsOverview(),
                allowed: self.allowance.assessments,
              },
              {
                text: 'Badges',
                key: 'global.vertNavbar.badges',
                url: self.urlLookup.badges(),
                allowed: self.allowance.badges,
              },
              {
                text: 'Surveys',
                key: 'global.vertNavbar.surveys',
                url: self.urlLookup.surveys(),
                allowed: self.allowance.surveys,
              },
              {
                text: 'Workshops',
                key: 'global.contentTypes.workshops',
                url: self.urlLookup.workshops(),
                allowed: self.allowance.workshops,
              },
            ].filter((item) => item.allowed),
            share: [
              {
                text: 'Assignments',
                key: 'dashboard.assignments',
                url: self.urlLookup.assignmentsV2(),
                allowed: self.allowance.assignmentsV2 ? self.allowance.assignments || self.allowance.workflows : self.allowance.assignments,

              },
              {
                text: 'Workflows',
                key: 'global.contentTypes.workflows',
                url: '#/overview/workflows',
                allowed: self.allowance.workflows && !self.allowance.assignmentsV2,
              },
            ].filter((item) => item.allowed),
            admin: [
              {
                text: 'Overview',
                key: 'global.overview',
                url: '#/overview/admin',
                allowed: self.allowance.overview,
              },
              {
                text: 'Developer Tools',
                key: 'global.developerTools',
                url: self.allowance.applicationTokens
                  ? self.urlLookup.api()
                  : self.urlLookup.webhooks(),
                allowed: self.allowance.applicationTokens || self.allowance.webhooks,
              },
              {
                text: 'Integrations',
                key: 'overview.settings.integrations',
                url: '#/overview/settings/integrations',
                allowed: self.allowance.settings,
              },
              {
                text: 'Profiles',
                key: 'overview.settings.access_profiles',
                url: self.urlLookup.viewAdminSettings('profiles'),
                allowed: self.allowance.profiles,
              },
              {
                text: 'Users',
                key: 'global.label.users',
                url: '#/overview/users',
                allowed: self.allowance.users,
              },
              {
                text: 'Registration Forms',
                key: 'overview.settings.registration_forms',
                url: '/admin/connect/registration-forms',
                allowed: self.allowance.registrationForms,
              },
              {
                text: 'Custom Fields',
                key: 'Custom Fields',
                url: '/admin/users/custom-fields',
                allowed: self.allowance.metadata,
              },
              {
                text: 'Reports',
                key: 'global.vertNavbar.reports',
                url: self.urlLookup.reports(),
                allowed: self.allowance.reports,
              },
              {
                text: 'Insights',
                key: 'global.vertNavbar.continuInsights',
                url: '/admin/insights',
                allowed: self.allowance.continuInsights,
              },
              {
                text: 'Extend',
                key: 'global.leftnav.extend',
                url: '/admin/extend',
                allowed: self.allowance.partners,
              },
              {
                text: 'Products',
                key: 'overviewProducts.products',
                url: '/overview/products',
                allowed: self.allowance.ecommerce,
              },
              {
                text: 'Theme',
                key: 'Theme',
                url: '#/overview/settings/theme',
                allowed: self.allowance.theme,
              },
            ].filter((item) => item.allowed),
            connect: [
              {
                text: 'Categories',
                key: 'overview.settings.tabs_categories',
                url: self.urlLookup.viewAdminSettings('categories'),
                allowed: self.allowance.connectCategories,
              },
              {
                text: 'Locations',
                key: 'overview.settings.tabs_locations',
                url: self.urlLookup.viewAdminSettings('locations'),
                allowed: self.allowance.connectLocations,
              },
              {
                text: 'Departments',
                key: 'overview.settings.tabs_departments',
                url: self.urlLookup.viewAdminSettings('departments'),
                allowed: self.allowance.connectDepartments,
              },
              {
                text: 'Teams',
                key: 'overview.settings.tabs_teams',
                url: self.urlLookup.viewAdminSettings('teams'),
                allowed: self.allowance.connectTeams,
              },
              {
                text: 'Levels',
                key: 'overview.settings.tabs_org_levels',
                url: self.urlLookup.viewAdminSettings('levels'),
                allowed: self.allowance.connectLevels,
              },
              {
                text: 'Grades',
                key: 'overview.settings.tabs_grades',
                url: self.urlLookup.viewAdminSettings('grades'),
                allowed: self.allowance.connectGrades,
              },
              {
                text: 'Groups',
                key: 'reports.fields.groups',
                url: self.urlLookup.viewAdminSettings('groups'),
                allowed: self.features.groups && self.allowance.connectGroups,
              },
              {
                text: 'Skills',
                key: 'overview.settings.tabs_skills',
                url: self.urlLookup.viewAdminSettings('skills'),
                allowed: self.allowance.connectSkills,
              },
            ].filter((item) => item.allowed),
          };

          self.isCurrentPageSubitem = () => {
            Object.keys(self.subnavs).forEach((key) => {
              let list = self.subnavs[key];
              list.map((item) => {
                if (item.url === window.location.hash) {
                  self.routeIsSubitem = true;
                  self.subitemParent = key;
                  self.previousSubnav = key;
                  self.currentLocation = item.url;
                }
              });
            });
          };
          self.isCurrentPageSubitem();

          $scope.$on('$routeChangeSuccess', function (currentRoute, previousRoute) {
            self.shutterAll();
            self.isCurrentPageSubitem();
          });

        },
      ],
      controllerAs: 'nav',
    };
  },
]);
